export default __webpack_public_path__ + "static/media/AssetSwap.c73709a9.svg";